import { styled } from 'parkdepot-shared/theme'

export const FullWrapper = styled('div', ({ $theme }) => ({
    height: '100%',
    overflowY: 'auto',

    [$theme.mediaQuery.large]: {
        width: '37.5rem',
        margin: '0 auto'
    }
}))

export const Title = styled('h3', ({ $theme }) => ({
    ...$theme.typography.HeadingXSmall,
    fontWeight: 600,
    textAlign: 'center',
    margin: '2rem 0 4rem',

    [$theme.mediaQuery.large]: {
        ...$theme.typography.HeadingSmall,
        padding: 0
    }
}))
